import React from 'react'
import PropTypes from 'prop-types'

import Header from '../Header'
import Footer from '../Footer'
import Preloader from '../Preloader'

import '../../assets/sass/styles.scss'

const Layout = ({ children }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  return (
    <>
      <Header />
      <Preloader />
      {children}
      <div onClick={() => scrollToTop()} className='go-top box-shadow background-second-color'>
        <span className='arrow_carrot-up' />
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
